export default "__VITE_ASSET__Bkcv1IV$__"